import React, { Component } from 'react'

import PresetManager from './PresetManager'
import StatusLogos from './StatusLogos'

export default class EditorHeader extends Component {

  componentDidMount() {
    /*
      schedule a series of startup actions with requestIdleCallback
      each task gets executed sequentially and efficiently
    */
  }

  render() {
    return (
      <header>
        <PresetManager />
        <StatusLogos />
      </header>
    )
  }
}
